export function price(prices, key) {
  if (!prices) {
    return "-";
  } else {
    const items = prices.filter((value, index) => value.key === key);
    if (items.length === 0) {
      return "-";
    }
    const item = items[0];
    return item.price / 100;
  }
}

export function monthly(prices, key) {
  if (!prices) {
    return "-";
  } else {
    const items = prices.filter((value, index) => value.key === key);
    if (items.length === 0) {
      return "-";
    }
    const item = items[0];
    return item.monthly_payment / 100;
  }
}

export function name(prices, key) {
  if (!prices) {
    return key;
  } else {
    const items = prices.filter((value, index) => value.key === key);
    if (items.length === 0) {
      return key;
    }
    return items[0].name;
  }
}
